import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SeasonToken } from '@sleed/bizcommerce-api';
import { seasonsApi } from '~/lib/api/client';
import { formToToken, type SeasonFormValues } from '~/lib/schemas/season';

export const seasonKeys = {
	all: ['seasons'] as const,
	list: () => [...seasonKeys.all, 'list'] as const
};

export function useSeasonsList() {
	return useQuery<SeasonToken[]>({
		queryKey: seasonKeys.list(),
		queryFn: async () => (await seasonsApi.getAll()).data.items ?? []
	});
}

export function useSeasonMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: seasonKeys.list() });
	const create = useMutation({
		mutationFn: async (form: SeasonFormValues) => (await seasonsApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: SeasonFormValues) => (await seasonsApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await seasonsApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
